__turbopack_context__.v({
  "auxBtns": "GalleryHeader-module__anqGWW__auxBtns",
  "backButton": "GalleryHeader-module__anqGWW__backButton",
  "header": "GalleryHeader-module__anqGWW__header",
  "nums": "GalleryHeader-module__anqGWW__nums",
  "slideShowGalleryHeader": "GalleryHeader-module__anqGWW__slideShowGalleryHeader",
});
